import Button from 'presentation/shared/components/Button'
import TextArea from 'presentation/shared/components/TextArea'
import React, { useState } from 'react'

type Props = {
  setNewComment: (comment: string) => void
}

export function AmbulatoryScheduleAddComment({ setNewComment }: Props) {
  const [comment, setComment] = useState<string>()

  const onSubmit = async () => {
    if (comment) {
      setNewComment(comment)
      setComment(undefined)
    }
  }

  return (
    <>
      <TextArea
        label="Deixar comentário"
        style={{ width: '100%', marginTop: '24px' }}
        rows={4}
        bgColor="mainBg"
        value={comment || ''}
        onChange={(e) => setComment(e.currentTarget.value)}
      />
      <div
        style={{
          display: 'flex',
          marginTop: '20px',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          style={{ padding: '10px', height: '40px', width: '200px' }}
          disabled={!comment}
          onClick={onSubmit}
        >
          Salvar
        </Button>
      </div>
    </>
  )
}
